const banks = state => state.banks
const parsedBanks = state => state.banks.filter(item => ['privat', 'aval'].includes(item.alias))
const isLoading = state => state.isLoading
const hasError = state => state.error !== null
const error = state => state.error
const hasBanks = state => state.banks.length > 0

export default {
  banks, parsedBanks, isLoading, hasError, error, hasBanks,
}
